import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ModalTitle = styled(Typography)(({ theme }) => ({
	alignSelf: "flex-start",
	marginBottom: theme.spacing(4),
}));
